import {useApi} from "../../../../../hooks/useApi";
import {useCallback, useState} from "react";
import {Query, QueryResult} from "material-table";
import _, { filter } from "lodash";
import {Client, Balance} from "../../../../../api/api";
import {DateTime} from "luxon";
// import {column2field} from "../../../transaction/tabs/transfers/hooks/useTransfersLoader";

export interface BalancesRequest {
  id ?          : number,
  portfolioId ? : number,
  offset ? : number,
  limit  : number,
  fromDateTime ? : string,
  'orderBy' ? : string,
  'direction' ? : "asc" | "desc",
}

export interface BalanceRow {
  date: string,
  quantity: number,
  asset: string
}

function balance2row(p: Balance): BalanceRow {
  return {
    date: p.timepoint,
    quantity: Number(p.currentTotalPosition),
    asset: p.assetName,
  };
}

function makeQueryResult(data: BalanceRow[] = [], page: number = 0, totalCount: number = 0):QueryResult<BalanceRow> {
  return {
    data,
    page,
    totalCount
  }
}

export function column2field(src?: string): string|undefined {
  switch (src) {
    case "asset": return "assetId"
    case "date": return "assetId" 
    default: return src
  }
}

export function useHistoricalBalancesLoader(portfolioId?: number, fromDateTime?: DateTime) {
  const {api} = useApi(),
    [isLastPage, setLastPage] = useState(false)

  const loader = useCallback( async  (q: Query<BalanceRow>): Promise<QueryResult<BalanceRow>> => {
    const offset = q.page * q.pageSize;
    const fromDateTimeISO = fromDateTime?.toISO();

    let req: BalancesRequest = {
      id: 0,
      fromDateTime: fromDateTimeISO !== null ? fromDateTimeISO : undefined,
      portfolioId: portfolioId,
      offset,
      limit: q.pageSize,
      orderBy: column2field(q.orderBy?.field),
      direction: q.orderDirection
    }

    for(let i=0;i<q.filters.length;i++) {
      const f = q.filters[i]
      if (f.column.field === 'asset') {
        const id: number = f.value
        req = {...req, id}
      }

      if (f.column.field === 'date') {
        const {start} = f.value;
        req = {...req, fromDateTime: start.toISO()}
      } else if(f.column.field === 'clientId') {
        const client: Client = f.value
        if (client) {
          const pId = client.clientPortfolioId
          req = {...req, portfolioId: pId}
        }
      }
    }
    try {
      const res = await api.getHistoricalBalancesbyDate(req)
      if (res.status === 200) {
        const balances: BalanceRow[] = _.map(res.body.items, balance2row)
        setLastPage(!res.body.paginationMetadata.hasNextPage) 
        return makeQueryResult(balances.slice(0,req.limit), q.page, offset+balances.length)
      }      
      
    } catch (e) {
      console.error(e)
    }
    return makeQueryResult()
  }, [api, fromDateTime, portfolioId])

  return {loader, isLastPage}
}
